import { cn } from '@/lib/utils';

export function GoogleCalendarIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/google-calendar.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}
